import React, { Component } from "react";

class NewModelFeatues extends Component {
  state = {
    accord_open: true
  };
  toggle_state = e => {
    e.preventDefault();
    this.setState({
      accord_open: !this.state.accord_open
    });
  };

  sentenceCase = (str) => {
  if (!str || typeof str !== 'string' || str == 'sst') return str;
  
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  }  

  formatNumberValue = (value) => {
    // Convert Indian number format (1,00,000) to US format (100,000)
    if (!value || typeof value !== 'string') return value;
    
    // Remove all commas first
    const numberWithoutCommas = value.replace(/,/g, '');
    
    // Check if it's a valid number
    if (isNaN(numberWithoutCommas)) {
      return value;
    }
    
    // Convert to number and back to string with US formatting
    const number = parseFloat(numberWithoutCommas);
     
    // Format with US comma separation (every 3 digits)
    const result = number.toLocaleString('en-US');    
    return result;
  }

  formatDisplayValue = (value) => {
  if (!value || typeof value !== 'string') return value;
  
  // Handle Unicode escape sequences dynamically
  let formattedValue = value;
  
  // Replace Unicode escape sequences with their actual characters
  formattedValue = formattedValue.replace(/\\u([0-9a-fA-F]{4})/g, (match, unicode) => {
    return String.fromCharCode(parseInt(unicode, 16));
  });
  
  // Handle specific Unicode patterns without backslash (like u2015, u00b0)
  const unicodeMap = {
    'u2015': '-',
    'u00b0': '°',
    'u2013': '–',
    'u2014': '—',
    'u00a0': ' ',
    'u2026': '…',
    'u00ae': '®',
    'u2122': '™',
    'u00a9': '©',
    'u00b1': '±',
    'u00d7': '×',
    'u00f7': '÷',
    'u2264': '≤',
    'u2265': '≥'
  };
  
  // Replace known Unicode patterns
  Object.keys(unicodeMap).forEach(unicodeKey => {
    const regex = new RegExp(unicodeKey, 'gi');
    formattedValue = formattedValue.replace(regex, unicodeMap[unicodeKey]);
  });
  
  if (formattedValue.toLowerCase().includes('defrost')) {
    return this.sentenceCase(formattedValue);
  }
  
  // Check if the value contains numbers with commas (any format)
  // This will catch both Indian (10,00,000) and US (1,000,000) formats
  if (/^\d+(?:,\d+)*(?:\.\d+)?$/.test(formattedValue.trim())) {
    return this.formatNumberValue(formattedValue);
  }

  // Check if it's a plain number without commas
  if(!isNaN(formattedValue)) {
    return this.formatNumberValue(formattedValue);
  }
  
  return formattedValue;
};

  render() {
    let p = [];
  
    Object.keys(this.props.datas).forEach(key => {
      p.push({
        key: key,
        value: this.props.datas[key]
      });
    });

    const button_type = this.state.accord_open
      ? "fa-minus-circle"
      : "fa-plus-circle";
    const visible = this.state.accord_open ? "block" : "none";
    return (
      <div className="NewModelFeatures">
        <div className="copare-list-heading">
          <strong>{this.props.title}</strong>
          <a href="#">
            <i
              onClick={this.toggle_state}
              className={"fa " + button_type}
              aria-hidden="true"
            />
          </a>
        </div>
        <div style={{ display: visible }}>
          {p.map((data, index) => {
            return (
              <ul
                key={"legacy" + index}
                className="compare-list all-list compare-lis"
              >
                <li>
                  <span>{data.key==="Selection Capacity"?"Application Capacity":data.key}</span>
                </li>
                <li>
                  <p>{data.value[this.props.mesurement_system]? this.formatDisplayValue(data.value[this.props.mesurement_system]): "-"}</p>
                </li>
              </ul>
            );
          })}
        </div>
      </div>
    );
  }
}
export default NewModelFeatues;
